import * as React from "react";
import * as Sentry from "@sentry/react";
import { useNavigate, useRouteError } from "react-router-dom";

/**
 * Route-level error fallback for React Router v6.
 * Replaces only the route content area — header and footer stay visible.
 * Used as errorElement on critical routes.
 */
export function RouteErrorFallback() {
	const error = useRouteError();
	const navigate = useNavigate();

	React.useEffect(() => {
		console.error("RouteErrorFallback caught an error:", error);
		if (error instanceof Error) {
			Sentry.captureException(error);
		} else {
			Sentry.captureMessage("RouteErrorFallback: non-Error thrown", { extra: { error } });
		}
	}, [error]);

	return (
		<div
			className="flex flex-col items-center justify-center px-6 py-16 text-center font-body"
			role="alert"
			aria-live="assertive"
		>
			<h2 className="text-2xl font-semibold text-foreground mb-2">
				Något gick fel på denna sida
			</h2>
			<p className="text-text-secondary text-md mb-8 max-w-md">
				Ett oväntat fel har inträffat. Du kan försöka gå tillbaka eller ladda om sidan.
			</p>
			<div className="flex gap-3">
				<button
					onClick={() => navigate(-1)}
					className="px-6 py-2.5 text-md font-medium rounded-md border border-border bg-background text-foreground cursor-pointer transition-colors duration-normal hover:bg-surface-raised focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
					aria-label="Gå tillbaka till föregående sida"
				>
					Gå tillbaka
				</button>
				<button
					onClick={() => window.location.reload()}
					className="px-6 py-2.5 text-md font-medium rounded-md border border-border-accent bg-primary text-primary-foreground cursor-pointer transition-colors duration-normal hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
					aria-label="Ladda om sidan"
				>
					Ladda om sidan
				</button>
			</div>
		</div>
	);
}
